import * as React from 'react';
import { DetailedHTMLProps, FC, HTMLAttributes } from 'react';
import { StatusVariant } from '@tcl-argon-utils/utils';
import { mergeClasses } from '@tcl-argon-utils/utils';
import { useBannerStyles } from './styles';

type DivElement = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export interface BannerProps extends DivElement {
  classes?: Record<string, string>;
  /** status either 'success' | 'error' | 'warning' | 'default' changes colors to visually reflect status of banner */
  status: StatusVariant;
  /** An icon component to be displayed to the left of the banner message. Pass in the component directly i.e. `<Banner icon={Success} message="Banner Message" />`. This can technically be anything, but should be a TCL Icon. */
  Icon?: React.ComponentType<{ className?: string; height?: string | number; width?: string | number }>;
  /** Text to be displayed in the banner */
  message?: string;
  /** label passed to the banner wrapper for screen reader use */
  ariaLabel: string;
}

export const Banner: FC<BannerProps> = ({
  className = '',
  classes: classOverrides = {},
  status = 'default',
  Icon,
  message,
  ariaLabel,
  ...props
}) => {
  const classes = mergeClasses(useBannerStyles({ status, ariaLabel }), classOverrides, { root: className });

  return (
    <div className={classes.root} aria-label={ariaLabel} role="banner" data-analytics={`${status}-banner`} {...props}>
      <div className={classes.content}>
        {Icon && <Icon height="14px" width="14px" className={classes.icon} />}
        {message && <div>{message}</div>}
      </div>
    </div>
  );
};
